import { adminHttpClient } from '../../commons/adminHttpClient'

const getCannedMessageById = (messageId: string | undefined) => {
  return adminHttpClient.get(`DocReview/CannedMessages/${messageId}`)
}

export default getCannedMessageById
